@for (menu of submenus; track menu.id) {
  <mat-menu>
    <div class="dropdown-menu">
      @for (item of menu; track item.id) {
        @if (item.test !== -1 && initComplete) {
          <button
            mat-menu-item
            [matMenuTriggerFor]="getMenu(item.test)"
            [class.menu-item-active]="isHighlighted(item.id)"
            class="menu-item-btn"
            [class.large-view]="menuState === SideNavMenuStates.LARGE_ICONS"
            [attr.accesskey]="item.accessKey || null"
            [attr.aria-keyshortcuts]="item.accessKey ? 'Alt+' + item.accessKey : null"
            >
            <span class="menu-text">
              {{item.name}}
              @if (item.count && item.count > 0) {
                <span class="menu-count">
                {{item.count > 9 ? '9+' : item.count}}</span>
              }
            </span>
          </button>
        }
        @if (item.test === -1) {
          <button
            mat-menu-item
            (click)="onClick(item.id)"
            [class.menu-item-active]="isHighlighted(item.id)"
            class="menu-item-btn"
            [class.large-view]="menuState === SideNavMenuStates.LARGE_ICONS"
            [attr.accesskey]="item.accessKey || null"
            [attr.aria-keyshortcuts]="item.accessKey ? 'Alt+' + item.accessKey : null"
            >
            <span class="menu-text">
              {{item.name}}
              @if (item.count && item.count > 0) {
                <span class="menu-count">
                  {{item.count > 9 ? '9+' : item.count}}
                </span>
              }
            </span>
          </button>
        }
      }
    </div>
  </mat-menu>
}
